import * as actionTypes from 'action-types'

const initialState = {
	committeeList: [],
	eventList: []
}

const eventSearchReducer = (state = initialState, action) => {
	switch (action.type) {
	case actionTypes.GET_COMMITTEE_LIST:
		return {
			...state,
			committeeList: action.committeeList
		}

	case actionTypes.GET_EVENT_LIST:
		return {
			...state,
			eventList: action.eventList
		}

	default:
		return state
	}
}

export default eventSearchReducer
